import { DataSourceAction, DataSourceExecutionEvent, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutTrackingHistory } from "./autogen/AutogenLayoutTrackingHistory";
import { ModelRow } from "@mcleod/core";
import { CommonTooltips } from "@mcleod/common";

export class TrackingHistory extends AutogenLayoutTrackingHistory {
    private showMessages: boolean = false;

    onLoad(): void | Promise<void> {
        this.tabsetTractorHistory["_tabRow"].visible = false;
    }

    switchToMessages() {
        this.showMessages = true;
        this.switchPositionCallin.rightCaption = "MC Messages";
    }

    /** This is an event handler for the afterExecution event of sourceEquipmentPositionsAndCallins. */
    sourceEquipmentPositionsAndCallinsAfterExecution(event: DataSourceExecutionEvent) {
        if (event.getAction() === DataSourceAction.SEARCH) {
            const positions = this.activeRow.get("positions").map(position => new ModelRow(this.sourceEquipmentPositionsAndCallins.url, false, position));
            if (positions.length == 0) {
                this.switchPositionCallin.checked = true;
            }

            this.tablePositions.data = positions;
            this.tablePositions.displayData(null, positions, 0);
            if (this.showMessages) {
                const messages = this.activeRow.get("messages")?.map(message => new ModelRow(this.sourceEquipmentPositionsAndCallins.url, false, message));
                this.tableCommMessages.data = messages;
                this.tableCommMessages.displayData(null, messages, 0);
            } else {
                const callins = this.activeRow.get("callins").map(callin => new ModelRow(this.sourceEquipmentPositionsAndCallins.url, false, callin));
                this.tableCallins.data = callins;
                this.tableCallins.displayData(null, callins, 0);
            }
            this.tableCommMessages.applySort("message_send", "desc", false);
        }
    }

    /** This is an event handler for the onChange event of switchPositionCallin. */
    switchPositionCallinOnChange(event) {
        if (event.newValue) {
            this.showMessages ? this.tabCommMessages.select() : this.tabCallins.select();
        } else {
            this.tabPositions.select();
        }
    }

    tableCommMessagesOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data as ModelRow;
        const labelMessage = tableRow.findComponentById("labelMessageMessage");
        const labelTitle = tableRow.findComponentById("labelMessageTitle");
        const isFreeForm = "0" === modelRow.get("message_form_num");
        labelMessage.visible = isFreeForm;
        labelTitle.visible = !isFreeForm;
        CommonTooltips.setTooltipContentLayout(
            labelTitle,
            modelRow.get("message_id"),
            "lme/dispatch/mobilecomm/MobileCommMessageQuickInfo"
        );
    }
}

